import React from 'react'

const DownChevron = props => (
  <svg
    viewBox='0 0 10 7'
    width={props.width || '10.05px'}
    height={props.height || '6px'}
  >
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g
        transform='translate(-1.000000, 0.000000)'
        fill='#333333'
        fillRule='nonzero'
      >
        <path d='M6,6.5 C5.73419702,6.50153676 5.47871883,6.39718651 5.29,6.21 L1.29,2.21 C1.03634142,1.95634143 0.937276461,1.58662601 1.03012194,1.24012195 C1.12296742,0.893617895 1.3936179,0.622967418 1.74012195,0.53012194 C2.08662601,0.437276461 2.45634143,0.536341419 2.71,0.79 L6,4.1 L9.3,0.92 C9.55076109,0.641167092 9.93644798,0.526067831 10.2990098,0.621868816 C10.6615717,0.7176698 10.9400601,1.00826644 11.0203532,1.37457496 C11.1006463,1.74088348 10.9692464,2.12132571 10.68,2.36 L6.68,6.22 C6.49712489,6.39631507 6.254003,6.49642408 6,6.5 L6,6.5 Z' />
      </g>
    </g>
  </svg>
)

export default DownChevron
